module.exports = __webpack_public_path__ + "img/pittsburgh1.b59d53e8.jpg";